import { StreakCompletionResult, StreakToastMessageMap } from './user_streak';
import { LeagueWeeklyResult } from './league_weekly_result';
import { LeagueCompletionCard } from './league_completion_card';
import { VideoSrc } from './video';
export class CountLesson {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "colorCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "durationSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coachImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.colorCode = data.colorCode;
        this.durationSeconds = data.durationSeconds;
        this.coachImageSrc = data.coachImageSrc ? config.cdnBaseURL + data.coachImageSrc : '';
    }
    get durationMinutes() {
        return Math.ceil(this.durationSeconds / 60);
    }
}
export class CountLessons {
    constructor(data, config) {
        Object.defineProperty(this, "selectedCoachId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.selectedCoachId = data.selectedCoachId;
        this.lessons = data.lessons.map((v) => new CountLesson(v, config));
    }
}
export class CountLessonDetailExercise {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "repSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "animationSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "voiceSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.mets = data.mets;
        this.repSeconds = data.repSeconds;
        this.orderIndex = data.orderIndex;
        this.animationSrc = '';
        if (data.animationSrc) {
            this.animationSrc = /\.m3u8(?:[?#]|$)/i.test(data.animationSrc)
                ? config.cdnBaseForMovie + data.animationSrc
                : new VideoSrc(data.animationSrc, config).hlsURL;
        }
        this.voiceSrc = data.voiceSrc ? config.cdnBaseURL + data.voiceSrc : '';
    }
}
export class CountLessonDetail {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bgmSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // 開始時のカウントダウンSE。全レッスン共通
        Object.defineProperty(this, "lessonCountdownSeSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // エクササイズ終了時のカウントダウンSE。全レッスン共通
        Object.defineProperty(this, "exerciseCountdownSeSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // 休憩終了時のカウントダウンSE。全レッスン共通
        Object.defineProperty(this, "restCountdownSeSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // 種目間の休憩時間(秒)。レッスン内のどの種目間でも同じ値
        Object.defineProperty(this, "restSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "durationSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exercises", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.bgmSrc = data.bgmSrc ? config.cdnBaseURL + data.bgmSrc : '';
        this.lessonCountdownSeSrc = config.cdnBaseURL + (data.lessonCountdownSeSrc || '/count_lesson/countdown.mp3');
        this.exerciseCountdownSeSrc =
            config.cdnBaseURL + (data.exerciseCountdownSeSrc || '/count_lesson/exercise_countdown.mp3');
        this.restCountdownSeSrc = config.cdnBaseURL + (data.restCountdownSeSrc || '/count_lesson/rest_countdown.mp3');
        this.restSeconds = data.restSeconds;
        this.durationSeconds = data.durationSeconds;
        this.exercises = data.exercises.map((v) => new CountLessonDetailExercise(v, config));
    }
}
// カウントレッスン完了APIの結果。完了画面のオーバーレイ(ストリーク・リーグ)の出し分けに使う
export class CountLessonCompletionResult {
    constructor(data, config) {
        var _a, _b;
        Object.defineProperty(this, "playDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calorie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessonStreakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workoutStreakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueWeeklyResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueCompletionCard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.playDuration = data.playDuration;
        this.calorie = data.calorie;
        this.lessonStreakCompletionResult =
            data.streakCompletionResult && new StreakCompletionResult(data.streakCompletionResult, config);
        this.workoutStreakCompletionResult =
            data.workoutGoalAchievementStreakCompletionResult &&
                new StreakCompletionResult(data.workoutGoalAchievementStreakCompletionResult, config);
        const weeklyResult = (_a = data.leagueLessonCompletionResult) === null || _a === void 0 ? void 0 : _a.weeklyResult;
        this.leagueWeeklyResult = weeklyResult ? new LeagueWeeklyResult(weeklyResult, config) : undefined;
        const completionCard = (_b = data.leagueLessonCompletionResult) === null || _b === void 0 ? void 0 : _b.completionCard;
        this.leagueCompletionCard = completionCard ? new LeagueCompletionCard(completionCard, config) : undefined;
    }
    get firstDailyCompletionStreakCompletionResult() {
        return [this.lessonStreakCompletionResult, this.workoutStreakCompletionResult].filter((v) => v === null || v === void 0 ? void 0 : v.isFirstDailyCompletion)[0];
    }
    get streakCompletionResultToast() {
        var _a;
        // カウントレッスンのストリークはトースト不要。workout goal達成時のみトーストを出す
        return StreakToastMessageMap[(_a = this.workoutStreakCompletionResult) === null || _a === void 0 ? void 0 : _a.sourceType];
    }
}
